"use client";

import AuthLayout from "@/components/auth/auth-layout";
import { FormProvider } from "@/providers/form.provider";
import type { Login } from "@/types/containers/auth/login";
import { loginSchema } from "@/utils/validations/auth/login";
import LoginCard from "./login-card";

const LoginScreen = () => {
  return (
    <AuthLayout>
      {/* Login Card */}
      <FormProvider<Login>
        schema={loginSchema}
        defaultValues={{ identifier: "" }}
      >
        <LoginCard />
      </FormProvider>
    </AuthLayout>
  );
};

export default LoginScreen;
